import { render, staticRenderFns } from "./SessionTimeout.vue?vue&type=template&id=5956feda"
import script from "./SessionTimeout.vue?vue&type=script&lang=ts"
export * from "./SessionTimeout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports